import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'edex-transaction-row',
  templateUrl: './transaction-row.component.html',
  styleUrls: ['./transaction-row.component.scss']
})
export class TransactionRowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
